import { Typography } from "@mui/material";
import { ReactElement } from "react";

import theme from "~frontend/theme";

import { FlexBox } from "../FlexBox";
import Loading from "../Loading";
import { DataContainer } from "./DataContainer";

export function TopLineStat({
  label,
  value,
}: {
  label: string;
  value: string | null;
}): ReactElement {
  return (
    <DataContainer
      sx={{
        width: `calc((100% - ${theme.spacing(2)}) / 3)`,
        height: "93px",
      }}
    >
      <FlexBox
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ width: "100%", height: "100%" }}
      >
        {value === null ? (
          <Loading size={30} style={{ margin: 0 }} />
        ) : (
          <Typography variant="display1Bold">
            {value.toLocaleString()}
          </Typography>
        )}
        <Typography variant="body2Bold">{label}</Typography>
      </FlexBox>
    </DataContainer>
  );
}
